import { Empty, Result } from 'antd';
import React from 'react';

const EmptyStatePage = () => (
  <div className="empty-data flex-grow-1 d-flex justify-center align-center">
    <Result
      icon={<Empty description={false} />}
      title="Sorry! No data found!!"
    />
  </div>
);
export default EmptyStatePage;
